import { Component } from "react";
import { Bar } from "react-chartjs-2";
import * as React from "react";

import Axios from "axios";
import { connect } from "react-redux";

const DATE_OPTIONS = {
  month: "short",
  day: "numeric",
};

class FTChart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: {},
    };
  }

  componentDidMount() {
    Axios.get(
      `https://www.24-crm.tn/webservice/api/FACCLIs?typppeeee=FT&coddos=${this.props.ConfigDossier.coddos}&serveur=${this.props.ConfigDossier.serveur}&user=${this.props.ConfigDossier.utilisateur}&pwd=${this.props.ConfigDossier.pwd_serveur}&database=${this.props.ConfigDossier.database}`
    ).then((res) => {

      const ipl = res.data;

      let playername = [];

      let runscore = [];

      ipl.forEach((record) => {
        playername.push(
          new Date(record.datfac).toLocaleDateString("fr", DATE_OPTIONS)
        );

        runscore.push(record.sommemntbn);
      });

      this.setState({
        Data: {
          labels: playername,

          datasets: [
            {
              label: "Montant Facture / jour",

              data: runscore,

              backgroundColor:
                "rgb(220, 0, 78)",

              //   [ "rgb(220, 0, 78)",

              //   "rgb(220, 0, 78)",

              //   "rgb(220, 0, 78)",

              //   "rgb(220, 0, 78)",

              //   "rgb(220, 0, 78)",

              //   "rgb(220, 0, 78)",

              //   "rgb(220, 0, 78)",

              //   "rgb(220, 0, 78)",

              //   "rgb(220, 0, 78)",
              // ],
              // borderColor: "rgba(0,0,0,1)",
              // borderWidth: 2,
            },
          ],
        },
      });
    });
  }
  render() {
    return (
      <div>
        <div>
          <Bar
            data={this.state.Data}
            options={{ maintainAspectRatio: false }}
            width={"300px"}
            height={"200px"}
          />
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    ConfigDossier: state.ConfigDossier,
  };
}
export default connect(mapStateToProps, null)(FTChart);
